export class EmbedPreview {
	boxShadowLevel: string;
	primaryColor: string;
	secondaryColor: string;
	fontFamily: string;
	buttonRadius: string;

	constructor(
		boxShadowLevel: string = '',
		primaryColor: string = '',
		secondaryColor: string = '',
		fontFamily: string = '',
		buttonRadius: string = ''
	) {
		this.boxShadowLevel = boxShadowLevel;
		this.primaryColor = primaryColor;
		this.secondaryColor = secondaryColor;
		this.fontFamily = fontFamily;
		this.buttonRadius = buttonRadius;
	}
}
